import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/core/api.service';
import * as _ from 'lodash';
import { TicketService } from '../../../../services/app/ticket.service';
import { FormControl, Validators } from '@angular/forms';
import { TcValidators } from 'src/app/validators/tc.validators';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/core/app.service';
import { BasketService } from '../../../../services/app/basket.service';
import { BasketTicketItem } from 'src/app/models/(basket)/Basket.model';
import { Router } from '@angular/router';
import { ToastrServiceCore } from 'src/app/services/core/toastr.service';
import { ConfigService } from 'src/app/initializer/config.service';

@Component({
  selector: 'app-ticket-main',
  templateUrl: './ticket-main.component.html',
  styleUrls: ['./ticket-main.component.css'],
})
export class TicketMainComponent implements OnInit {
  isRequestTicket: boolean = false;
  isSubmitTC: boolean = false;
  isShowTcValidate: boolean = false;
  isOpenSidebarBasket: boolean = false;
  backgroundUrl: string;
  phoneNumber: string;
  showBottomText: boolean = false;
  constructor(
    public apiService: ApiService,
    public appService: AppService,
    public basketService: BasketService,
    public ticketService: TicketService,
    private toastrServiceCore: ToastrServiceCore,
    private configService: ConfigService,
  ) {
    if (this.configService.hotelId == 25860) {
      this.showBottomText = true;
    }
    this.appService.settings$.value?.TICKET_PAGE_BACKGROUND_URL
      ? `url("${this.appService.settings$.value?.TICKET_PAGE_BACKGROUND_URL}")`
      : 'none';

    if (this.ticketService.tickets$.value == null) {
      // this.appService.progressBool();
      // this.ticketService.getAllData();
    } else {
      this.isOpenSidebarBasket = false;
    }
  }
  ngOnInit() {
    this.appService.language$.subscribe(async (data) => {
      if (data) {
        this.appService.progressBool();
        await this.ticketService.getAllData();
        if (this.appService.settings$.value.DEFAULTFOREIGNROUTE) {
          this.appService.progressBool(false);
          this.isLocalCheck(false);
          this.appService.progressBool(false);
        }

        if (this.appService.isLocal$.value != null) {
          this.ticketService.mappingAfterGetData(
            this.ticketService.tickets$.value,
          );
          this.appService.progressBool(false);
        }
      }
    });
  }
  isOpenSidebarBasketFunc() {
    this.isOpenSidebarBasket = !this.isOpenSidebarBasket;
  }

  isLocalCheck(local: boolean) {
    this.isRequestTicket = true;

    this.appService.progressBool();

    this.ticketService.isLocalCheck(local);
  }

  deleteItem(BasketTicket: BasketTicketItem) {
    this.basketService.deleteTicketItem(BasketTicket);
  }
  ticketFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(11),
    Validators.maxLength(11),
    Validators.pattern('[0-9]*'),
    TcValidators.isValidTc,
  ]);
  validationTC() {
    this.isSubmitTC = true;
    if (this.ticketFormControl.valid) {
      this.isLocalCheck(true);
    } else {
      this.toastrServiceCore.error('Please enter a valid Turkish ID number.');
    }
  }
}
